import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useContext } from 'react'

import {TodoContext} from '../API'

let crypto = require("crypto");

const Input=()=>{

    
    const [todo,setTodo]=useContext(TodoContext)
    const[input,setInput]=useState("")

    const change=(e)=>{
        setInput(e.target.value)
    }

    const onSubmit=(e)=>{
        e.preventDefault()
        if(input!==""){        
        setTodo([...todo,{id:crypto.randomBytes(4).toString('hex'),title:input,isComplete:false}])
        setInput("")
    }

    else{
        return
    }
    }

  
   
    return(
        <form className="mb-4">
            <input type="text" className="form-control" placeholder="Enter your task here" value={input} onChange={(e)=>change(e)}/>
            <button type="submit" className="submit" onClick={(e)=>onSubmit(e)}></button>
        </form>
    )
}

export default Input